import { useEffect, useState } from "react";
import { AnimatedUploadAnalysis } from "@/components/Icons/AnimatedUploadAnalysis";
import { LoadingSteps } from "@/components/LoadingSpinner/LoadingSteps";
import { AppText } from "@/components/Text/AppText";
import { translate } from "@/helper/translate";

export const ImportJobDetailsLoading = () => {
    const [showDelayMessage, setShowDelayMessage] = useState(false);

    const loadingSteps = [
        {
            label: `${translate("Analysing", "title")} job description...`,
        },
        {
            label: "Identifying key responsibilities...",
        },
        {
            label: "Extracting required skills...",
        },
        {
            label: `${translate("Summarising", "title")} job requirements...`,
        },
        {
            label: `${translate("Optimising", "title")} for best fit...`,
        },
        {
            label: `${translate("Finalising", "title")} job analysis...`,
        },
    ];

    useEffect(() => {
        const delayTimer = setTimeout(() => {
            setShowDelayMessage(true);
        }, 15000);

        return () => clearTimeout(delayTimer);
    }, []);

    return (
        <div className="flex min-h-[200px] flex-1 flex-col items-center justify-center gap-2">
            <div className="mb-2 text-center">
                <AppText
                    variant="contextheading"
                    className="mt-2 text-neutral-900"
                >
                    {translate("Analysing", "title")} job details...
                </AppText>
            </div>

            <LoadingSteps
                steps={loadingSteps}
                autoProgress={true}
                stepDuration={4000}
                loop={false}
                icon={<AnimatedUploadAnalysis className="h-10 w-10" />}
            />

            <div className="mt-3 text-center">
                <AppText
                    variant="footnote"
                    className="text-neutral-600"
                >
                    {showDelayMessage
                        ? "We're still processing your job description—this is taking longer than usual, but we're on it!"
                        : "It should be ready shortly!"}
                </AppText>
            </div>
        </div>
    );
};
